import { render, staticRenderFns } from "./laboratoryCategory.vue?vue&type=template&id=30a206f0"
import script from "./laboratoryCategory.vue?vue&type=script&lang=js"
export * from "./laboratoryCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports